// import React, { useState } from "react";
// import "./adminloginstyle.css";
// import Navbar from "../../Components/Navbar";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faEnvelope, faLock, faSignInAlt } from "@fortawesome/free-solid-svg-icons";
// import { URL } from "../../config";
// import { useNavigate } from "react-router-dom";

// const AdminLogin = () => {
//   const navigate = useNavigate();
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [errMsg, setErrMsg] = useState("");

//   const loginHandleBtn = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await fetch(`${URL}/login`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({ email, password, role: "admin" }),
//       });

//       if (response.ok) {
//         const { token } = await response.json();
//         localStorage.setItem("token", token);
//         console.log("Admin successfully logged in. Token:", token);
//         navigate("/admin/dashboard");
//       } else {
//         const error = await response.json();
//         const errorMessage = error.error || "Invalid credentials. Please try again.";
//         setErrMsg(errorMessage);
//         console.log("Login error:", errorMessage);
//       }
//     } catch (error) {
//       console.error("Error during login:", error);
//       setErrMsg("Internal server error");
//     }
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="adminlogin-container">
//         <div className="adminlogin-left-section">
//           <h1>HelpNao</h1>
//           <h5>Secure administrative access to manage your service platform and user experience.</h5>
//         </div>
//         <div className="adminlogin-right-section">
//           <div className="adminlogin-header">
//             <h2 className="adminlogin-text">Admin Login</h2>
//             <div className="adminlogin-underline"></div>
//           </div>
//           <form onSubmit={loginHandleBtn}>
//             <div className="adminlogin-form">
//               <div className="adminlogin-form-group adminlogin-input-container">
//                 <FontAwesomeIcon className="adminlogin-icon" icon={faEnvelope} />
//                 <input
//                   type="email"
//                   id="email"
//                   name="email"
//                   value={email}
//                   onChange={(e) => setEmail(e.target.value)}
//                   placeholder="admin@HelpNao.com"
//                 />
//               </div>
//               <div className="adminlogin-form-group adminlogin-input-container">
//                 <FontAwesomeIcon className="adminlogin-icon" icon={faLock} />
//                 <input
//                   type="password"
//                   id="password"
//                   name="password"
//                   value={password}
//                   onChange={(e) => setPassword(e.target.value)}
//                   placeholder="Enter your password"
//                 />
//               </div>
//             </div>
//             {errMsg && <div className="adminlogin-error-message">{errMsg}</div>}
//             <div className="adminlogin-button-container">
//               <button className="adminlogin-btn" type="submit">
//                 <FontAwesomeIcon icon={faSignInAlt} style={{ marginRight: "10px", color: "#fff" }} />
//                 Access Dashboard
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     </>
//   );
// };

// export default AdminLogin;




import React, { useState, useEffect } from "react";
import "./adminloginstyle.css";
import Navbar from "../../Components/Navbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faLock,
  faSignInAlt,
} from "@fortawesome/free-solid-svg-icons";
import { URL } from "../../config";
import { useNavigate } from "react-router-dom";

const AdminLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errMsg, setErrMsg] = useState("");


  // 🔒 If already logged in as admin, never show this page
  useEffect(() => {
    const adminToken = localStorage.getItem("adminToken");
    const rawRole = localStorage.getItem("role") || "";
    const role = rawRole.trim().toLowerCase();

    if (adminToken && role === "admin") {
      navigate("/admin/dashboard", { replace: true });
    }
  }, [navigate]);

  const loginHandleBtn = async (e) => {
    e.preventDefault();
    setErrMsg("");

    try {
      const response = await fetch(`${URL}/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password, role: "admin" }),
      });

      if (response.ok) {
        const data = await response.json();
        const { token, admin } = data;


        //  Clear any previous auth state (user/servitor/admin)
        localStorage.removeItem("token");
        localStorage.removeItem("adminToken");
        localStorage.removeItem("role");
        localStorage.removeItem("adminInfo");
        sessionStorage.clear();


        //  Store admin token & info (used by ProtectedRoute + AdminDash)
        localStorage.setItem("adminToken", token);
        localStorage.setItem("token", token);      // optional but useful as a generic auth token
        localStorage.setItem("role", "admin");     //  REQUIRED for ProtectedRoute

        //  Store admin token & info (used by ProtectedRoute + AdminDash + Admins.jsx)
        localStorage.setItem("adminToken", token);
        if (admin) {
          localStorage.setItem("adminInfo", JSON.stringify(admin));
        }

        // console.log("Admin successfully logged in. Token:", token);
        // navigate("/admin/dashboard");
        navigate("/admin/dashboard", { replace: true });
      } else {
        const error = await response.json();
        const errorMessage =
          error.error || "Invalid credentials. Please try again.";
        setErrMsg(errorMessage);
        console.log("Login error:", errorMessage);
      }
    } catch (error) {
      console.error("Error during login:", error);
      setErrMsg("Internal server error");
    }
  };

  return (
    <>
      <Navbar />
      <div className="adminlogin-container">
        <div className="adminlogin-left-section">
          <h1>HelpNao</h1>
          <h5>
            Secure administrative access to manage your service platform and
            user experience.
          </h5>
        </div>
        <div className="adminlogin-right-section">
          <div className="adminlogin-header">
            <h2 className="adminlogin-text">Admin Login</h2>
            <div className="adminlogin-underline"></div>
          </div>
          <form onSubmit={loginHandleBtn}>
            <div className="adminlogin-form">
              <div className="adminlogin-form-group adminlogin-input-container">
                <FontAwesomeIcon
                  className="adminlogin-icon"
                  icon={faEnvelope}
                />
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="admin@HelpNao.com"
                  required
                />
              </div>
              <div className="adminlogin-form-group adminlogin-input-container">
                <FontAwesomeIcon
                  className="adminlogin-icon"
                  icon={faLock}
                />
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                  required
                />
              </div>
            </div>
            {errMsg && (
              <div className="adminlogin-error-message">{errMsg}</div>
            )}
            <div className="adminlogin-button-container">
              <button className="adminlogin-btn" type="submit">
                <FontAwesomeIcon
                  icon={faSignInAlt}
                  style={{ marginRight: "10px", color: "#fff" }}
                />
                Access Dashboard
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AdminLogin;
